import { createRoot } from "@wordpress/element";
import Entidades from "./Entidades";

// Mount the component to the 'root' div
const root = document.getElementById('table-entidades');
if (root) {
  const filterEntidades = root.getAttribute('data-filter');
  createRoot(root).render(<Entidades
    filterEntidades={filterEntidades}
  />);
}
